import React, { useState, useEffect } from "react"
import { Link, useNavigate, useParams } from "react-router-dom"

//import components
import Breadcrumbs from "../../components/Common/Breadcrumb"

//redux
import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"

import {
  Button,
  Card,
  CardBody,
  CardText,
  CardSubtitle,
  CardTitle,
  Col,
  Container,
  Form,
  Input,
  Label,
  Row,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Alert,
  UncontrolledTooltip,
} from "reactstrap"
import classnames from "classnames"
import { getSubjectDetail as onGetSubjectDetail } from "store/actions"
import { isEmpty } from "lodash"
import { useDeepCompareEffect } from "hooks"
import AlertContainer from "components/Common/AlertContainer"
import { CLEAR_HOUSEHOLD_STATE } from "store/household/actionTypes"
import EmptyContainer from "components/Common/EmptyContainer"
import BasicInfoTab from "./tabs/BasicInfoTab"

const SubjectAddEdit = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { id } = useParams()
  const [tabValue, setTabValue] = useState("1")
  const [header, setHeader] = useState("")

  //////////////////HOUSEHOLD STATE/////////////////////
  const { trainingsubject } = useSelector(state => state.household)
  //////////////////////////////////////

  useDeepCompareEffect(() => {
    if (id === "new") {
      setHeader("Add Training Subject")
    } else {
      setHeader("Edit Training Subject")
      dispatch(onGetSubjectDetail(id))
    }
  }, [dispatch, id])

  const { basicSetting } = useSelector(state => state.Layout)
  //meta title
  document.title =
    "Training Subject | " +
    (basicSetting?.SiteName || process.env.REACT_APP_NAME)

  const toggleTab = tab => {
    if (tabValue !== tab) {
      setTabValue(tab)
    }
  }

  const NavItemTab = (navTitle, navValue, iconValue) => {
    return (
      <NavItem>
        <NavLink
          style={{ cursor: "pointer" }}
          className={classnames({
            active: tabValue === navValue,
          })}
          onClick={() => {
            toggleTab(navValue)
          }}
        >
          <span className="d-block d-sm-none">
            <i className={iconValue}></i>
          </span>
          <span className="d-none d-sm-block">{navTitle}</span>
        </NavLink>
      </NavItem>
    )
  }

  useEffect(() => {
    return () => {
      dispatch({ type: CLEAR_HOUSEHOLD_STATE })
    }
  }, [])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Training Subjects" breadcrumbItem={header} />
          {id !== "new" && isEmpty(trainingsubject) ? (
            <EmptyContainer
              backURL="/subjects"
              message="There is no such subject!"
              linkText="Go to Subjects Page"
            />
          ) : (
            <Row>
              <Col xs="12">
                <Card>
                  <CardBody>
                    <CardTitle>Basic Information</CardTitle>
                    <p className="card-title-desc mb-4">
                      Fill all information below to Complete the Subject Details
                      Below
                    </p>
                    {/* {id !== "new" ? (
                      <Nav tabs className="nav-tabs-custom nav-justified">
                        {NavItemTab(
                          "Basic Info",
                          "1",
                          "mdi mdi-information-outline"
                        )}
                      </Nav>
                    ) : (
                      ""
                    )}
                    <TabContent activeTab={tabValue} className="p-3 text-muted">
                      <TabPane tabId="1"> */}
                    <Row>
                      <Col sm="12">
                        <BasicInfoTab subject={trainingsubject} />
                      </Col>
                    </Row>
                    {/* </TabPane>
                    </TabContent> */}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default SubjectAddEdit
